import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FONT_GSS_FUTURA } from 'themes/default';
import { lightGray } from '../../styles/style-constants';
import { getRoutingForPage } from '../../util/workbook-util';
import { remCalc } from '../../util/style-util';
import GoToPageHeader from './GoToPageHeader';
import Keypad from './Keypad';
import { makeStyles } from '@mui/styles';

type Props = {
  currentPage: number;
  totalPages: number;
  closeMenu: () => void;
};

const GoToPage = (props: Props) => {
  const [keyedPageNumber, setKeyedPageNumber] = useState<string>('');

  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { isZoom } = params;

  const classes = useStyles();

  const deletePageNumberInput = () => {
    const newPage = keyedPageNumber.slice(0, -1);

    setKeyedPageNumber(newPage);
  };

  const changePageNumber = (newPage: string) => {
    if (isValidPageNumber(newPage)) {
      setKeyedPageNumber(newPage);
    }
  };

  const updatePageNumberInput = (page?: string) => {
    return (e: { target: { value: string } } & Event) => {
      if (!page) {
        return changePageNumber(e.target.value);
      }

      const currentPage = keyedPageNumber || '';

      changePageNumber(currentPage + page);
    };
  };

  const isValidPageNumber = (page: string): boolean => {
    const pageNumber = parseInt(page, 10);

    return (
      page === '' ||
      (Number.isInteger(pageNumber) && pageNumber >= 0 && pageNumber <= props.totalPages)
    );
  };

  const goToPage = () => {
    const { closeMenu } = props;
    let nextPage = parseInt(keyedPageNumber, 10);

    if (!nextPage) return;

    if (nextPage && nextPage % 2 !== 0 && !isZoom) {
      nextPage = nextPage - 1;
    }

    const pageRoute = getRoutingForPage(
      nextPage,
      { params, url: location.pathname },
      isZoom === 'zoom',
      true
    );

    navigate(pageRoute.path);
    closeMenu();
  };

  const pageNumberDisplay = Number.isNaN(props.currentPage) ? '-' : props.currentPage;

  return (
    <div className={classes.goToPage}>
      <GoToPageHeader
        totalPages={props.totalPages}
        newPageNumber={keyedPageNumber}
        handleInputChange={updatePageNumberInput()}
        handleDelete={deletePageNumberInput}
        currentPage={pageNumberDisplay}
      />
      <Keypad
        newPage={keyedPageNumber}
        makeKeyInputHandler={updatePageNumberInput}
        handleGoClick={goToPage}
      />
    </div>
  );
};

const useStyles = makeStyles(() => ({
  goToPage: {
    gridArea: 'main',
    backgroundColor: lightGray,
    borderRadius: '20px',
    padding: 0,
    margin: 'auto',
    fontFamily: `${FONT_GSS_FUTURA} !important`,
    fontSize: '14px !important',
    maxWidth: remCalc(330)
  }
}));

export default GoToPage;
